import React, { useState, useEffect } from "react";
import { getTopPunishment } from "../../services/firebase";
import { ContentItem } from "../../types";
import { useNavigate } from "react-router-dom";
import HoverVideoPlayer from "react-hover-video-player";
import defaultCardImage from "../../assets/PunishmentDefault.png";
import { css, keyframes } from "@emotion/css";

const TopPunishments: React.FC = () => {
  const [topPunishments, setTopPunishments] = useState<ContentItem[]>([]);
  const [focusedVideoId, setFocusedVideoId] = useState<string | null>(null);
  // Keyframes for loading spinner animation
  const loadingOverlaySpinnerAnimation = keyframes`
from {
    transform: rotate(0deg);
}
to {
    transform: rotate(360deg);
}
`;
  const navigate = useNavigate();
  useEffect(() => {
    (async () => {
      try {
        const fetchedPunishments = await getTopPunishment();
        setTopPunishments(fetchedPunishments);
      } catch (err) {
        console.log(err);
      }
    })();
  }, []);
  if (topPunishments.length === 0) return null;

  const handleNavigate = (slug: string | undefined) => {
    if (slug) {
      navigate(`/punishments/${slug}`);
    }
  };

  const renderVideoBlock = (content: ContentItem) => {
    return (
      <HoverVideoPlayer
        key={`${content.id}-card-player-${content.videoUrl}`} // Unique key for each video player
        pausedOverlayWrapperClassName="paused-overlay-card-wrapper" // Applies a custom class to the div wrapping the pausedOverlay contents
        hoverOverlayWrapperClassName="hover-overlay-card-wrapper" // Applies a custom class to the div wrapping the hoverOverlay contents
        videoClassName="card-player-video" // Applies a custom class to the video element
        videoId={content.id} // Applies an id to the video element
        videoSrc={content.videoUrl}
        //style={{ width: "295px", height: "360px" }}
        pausedOverlay={
          <img
            src={
              typeof content.image === "string" && content.image
                ? content.image
                : defaultCardImage
            }
            alt={content.title}
          />
        }
        loadingOverlayWrapperClassName={css`
          /* Loading overlay has semi-transparent background so the player
                will be darkened while it's visible */
          background-color: rgba(0, 0, 0, 0.7);
          /* Center the spinner inside of the overlay */
          display: flex;
          justify-content: center;
          align-items: center;
        `}
        loadingOverlay={
          <div>
            <div
              className={css`
                width: 4em;
                height: 4em;
                border: 6px solid white;
                border-radius: 50%;
                border-color: white white transparent transparent;
                animation: ${loadingOverlaySpinnerAnimation} 1s linear infinite;
              `}
            />
          </div>
        }
        className="punishmentVideo"
        loop={true}
        unloadVideoOnPaused={false}
        muted={true}
        overlayTransitionDuration={500}
        disablePictureInPicture={false}
        disableRemotePlayback={false}
        sizingMode="overlay"
        preload="auto"
        disableDefaultEventHandling={true}
        focused={focusedVideoId === content.id}
        loadingStateTimeout={300}
      ></HoverVideoPlayer>
    );
  };

  const extractPosition = (order: number) => {
    const itemOrder = order;
    if (itemOrder >= 0 && itemOrder < 25) {
      if (order < 10) {
        return "top10";
      } else {
        return "top25";
      }
    } else {
      return "";
    }
  };

  // const extractLevel = (flRating: string | undefined): number => {
  //   if (!flRating) return 1;

  //   // Check for format like "Cute & Fluffy (Level 1)"
  //   const levelMatch = flRating.match(/Level\s*(\d+)/i);
  //   if (levelMatch) {
  //     return parseInt(levelMatch[1]);
  //   }

  //   // Fallback check for format like "L1"
  //   const shortMatch = flRating.match(/L(\d+)/i);
  //   if (shortMatch) {
  //     return parseInt(shortMatch[1]);
  //   }

  //   return 1; // Default to level 1 if no match found
  // };

  return (
    <section className="topPunishments">
      <div className="wrapper">
        <div className="sectionHeading">Top 10 Punishments</div>
        {/* <ul className='topItemList'>
            {topPunishments.map((punishment: ContentItem) => (
              <li key={punishment.id} onClick={() => handleNavigate(punishment.slug)}>
                {punishment.title}
                <button className="btnTxt">VIEW DETAILS</button>
              </li>
            ))}
          </ul> */}
        <ul className="productList topProductList">
          {topPunishments.map((punishment: ContentItem) => (
            <li
              key={punishment.id}
              onClick={() => handleNavigate(punishment.slug)}
              style={{
                backgroundImage: !punishment.videoUrl
                  ? `url(${
                      punishment.mobileHeaderImage
                        ? punishment.mobileHeaderImage
                        : punishment.image
                    })`
                  : "",
              }}
              onMouseEnter={() => setFocusedVideoId(punishment.id)}
              onMouseLeave={() => setFocusedVideoId(null)}
            >
              <div className="listLeftCont">
                {punishment.videoUrl ? renderVideoBlock(punishment) : null}
                {extractPosition(
                  punishment.order != undefined ? punishment.order : -1
                ) !== "" && (
                  <div className="topPosition">
                    {`#${
                      punishment.order !== undefined ? punishment.order + 1 : ""
                    }`}
                  </div>
                )}
                <div className="favItemHeading">{punishment.title}</div>
                {/* <div
                  className={`levelBlk badge-${extractLevel(
                    punishment.flRating
                  )}`}
                >
                  Level {extractLevel(punishment.flRating)}
                </div> */}
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default TopPunishments;
